import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, signal, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DataSourceApi } from '@selfai-platform/pipeline-api';
import { DatasourceType } from '@selfai-platform/pipeline-common';

@Component({
  selector: 'selfai-platform-data-source-form-viewer',
  templateUrl: './data-source-form-viewer.html',
  styleUrls: ['./data-source-form-viewer.scss'],
  standalone: true,
  imports: [CommonModule, DatePipe, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataSourceFormViewerComponent implements OnChanges, OnInit {
  @Input() ds: string;

  parsedDs = signal<DataSourceApi | null>(null);
  dsParseError = signal(false);
  dsParseErrorText = signal('');

  ngOnInit(): void {
    this.parseDs();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ds']) {
      this.parseDs();
    }
  }

  getDataSourceTypeTranslationKey(type?: DatasourceType): string {
    const typeTranslationKeys: Record<string, string> = {
      libraryFile: 'data-source-list.toolbar.actions.create.library',
      s3: 'data-source-list.toolbar.actions.create.s3',
      kafka: 'data-source-list.toolbar.actions.create.kafka',
      hdfs: 'data-source-list.toolbar.actions.create.hd',
      googleSpreadsheet: 'data-source-list.toolbar.actions.create.google-spreadsheet',
      externalFile: 'data-source-list.toolbar.actions.create.external-file',
      jdbc: 'data-source-list.toolbar.actions.create.database',
      hive: 'data-source-list.toolbar.actions.create.hive',
    };

    return type ? typeTranslationKeys[type] || type : 'common.not-specified';
  }

  maskSensitiveData(value?: string): string {
    if (!value) return '***';
    if (value.length <= 8) return '***';

    return value.substring(0, 4) + '***' + value.substring(value.length - 4);
  }

  private parseDs(): void {
    try {
      this.dsParseError.set(false);
      this.parsedDs.set(JSON.parse(this.ds));
    } catch (error) {
      console.error(error);
      this.parsedDs.set(null);
      this.dsParseErrorText.set(error instanceof Error ? error.message : 'Unknown error');
      this.dsParseError.set(true);
    }
  }
}
